import { mergeToNewObject } from '../../../util/helpers'
import {WALLET_UNLOCK} from '../../../constants/actions'

export const unlockProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case WALLET_UNLOCK.ON_PASSWORD_CHANGE:
      return mergeToNewObject(state, { password: payload })
    case WALLET_UNLOCK.ON_RESET_STATE:
      return INITIAL_STATE
    case WALLET_UNLOCK.ON_WALLET_UNLOCK_ERROR:
      return mergeToNewObject(state, { error: payload })
    default:
      return state
  }
}

const INITIAL_STATE = {
  password: '',
  error: ''
}



// WEBPACK FOOTER //
// ./src/store/reducers/wallet/unlock.js